
import { useEffect ,useState} from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch,useSelector } from "react-redux";
import { getShopAdressbyID } from "../../../../store/actions/shopAction";
import ShopAdressViewCard from "../../../../utils/form/shopAdressViewCard";
import {
    Modal,
    Button,
    ButtonToolbar,
    ButtonGroup,
    InputGroup,
    FormControl
} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap'
import StoreIcon from '@mui/icons-material/Store';
import {
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Divider,
 
} from '@mui/material'




const ShopAdressView = () => {


    const shopinfo= useSelector(state=>state.shopReducer);
    const dispatch = useDispatch();
    const { id } = useParams();
    const navigate = useNavigate();
    let cntntUrl='/dashboard/shops/editadrssbytrns/';
    let urlAddContnt='/dashboard/shop/adrss/'+id;
    let urlNextContnt='/dashboard/shop/editcntinfo/'+id;
    const [loading,setLoading] = useState(true);

    const  goToOnclick=(data) => {
        //console.log(page)
        //dispatch(getPaginateArticles({page}))
        console.log('5555555555')
        console.log(data)
      //  shopinfo.currentContent=data;

        navigate(cntntUrl+data.shopId+'_'+data.trsnNo)
        console.log('5555555555')
        
        
    }  
    


  

      useEffect(()=>{
        
    
        dispatch(getShopAdressbyID(id))
        .unwrap()
          .then(response => {
  
               setLoading(false);
if( response!==null){

    if(response.message==='success')
                    {
                        console.log("111111111111111");
    
                        

                        console.log(response.adressList.length)
                        console.log("666666666666666666");
                       if(response.adressList.length===0)
                       {
                        navigate(`/dashboard/shop/adrss/${id}`)
                       }
                    
                    }
                     
   
         
                      }
  })
          
      },[id,dispatch])


    return(
        <>
        <hr/>
            <div className='adressInfocard'>

            <ButtonToolbar className='mb-3'>
                <ButtonGroup className='me-2'>
                    <LinkContainer to={urlAddContnt}>
                        <Button variant='secondary'>Add Adress</Button>
                    </LinkContainer>
                </ButtonGroup>
                <form>
                    <InputGroup>
                        <InputGroup.Text id="btngrp1">@</InputGroup.Text>
                        <FormControl
                            type='text'
                            placeholder='Search'
                        />
                    </InputGroup>
                </form>
            </ButtonToolbar>
                
            <Divider className='mt-3 mb-3'/>
                
                <div>   

                {  shopinfo && shopinfo.currentAdress  && shopinfo.currentAdress.adressList.length>>0 ?
                    <div className='mt-3 content'>

                { shopinfo.currentAdress.adressList.map((item,i)=>(

                      <div key={i}>

                   
                  <ShopAdressViewCard item={item}/>
                        




                        <div className='form-group'>
                       <ButtonGroup className='me-2'>
                   
                        <Button 
                        variant='link'
                        color="orange"
                        onClick={()=>goToOnclick(item)}
                        >
                            Edit Adress
                            </Button>
                    
                </ButtonGroup>
                </div>
            
                
                            </div>  
                            
                            
                               
                     
                                        
                                            
                        ))}
                        
                        
                   
                        
                        
                        

                            
              
                
                    </div>
                    :null
}                      
</div> 
               <Divider className='mt-3 mb-3'/>
                <ButtonGroup className='me-2'>
                    <LinkContainer to={urlNextContnt}>
                        <Button variant='primary'>NEXT</Button>
                    </LinkContainer>
                </ButtonGroup>
               
            </div>
           

        </>
    )
}

export default ShopAdressView